import { HubConnectionState } from '@microsoft/signalr';
import { TrafficLightType } from '@scaleaq/scaleui';

export const getConnectionTrafficLightType = (
  connectionState: HubConnectionState,
  isClosed: boolean
): TrafficLightType => {
  if (isClosed) return 'alarm';
  switch (connectionState) {
    case HubConnectionState.Connected:
      return 'success';
    case HubConnectionState.Connecting:
    case HubConnectionState.Reconnecting:
      return 'caution';
    case HubConnectionState.Disconnected:
      return 'alarm';
    default:
      return 'alarm';
  }
};
